<div class="post" [class.has-topic]="!!post().content.topic">
  @if (topic()) {
    <a [routerLink]="['/' + topic().content.page_url]" class="post-topic" (click)="$event.stopPropagation()">
      {{ topic().name }}
    </a>
  }
  <a class="post-link" [routerLink]="'/' + post().full_slug" [appStoryblok]="post()._editable">
    <div class="post-image">
      <img
        [src]="(post().content.keyVisual || post().content.visual)?.filename | storyblokCdn"
        [loading]="index() < 6 ? 'eager' : 'lazy'"
        [alt]="post().content.keyVisual?.alt || post().content.visual?.alt || ''"
      />
    </div>
    <div class="post-content">
      <h3>{{ post().content.title }}</h3>
      <span class="date">{{ post().first_published_at | date }}</span>
    </div>
  </a>
</div>
